﻿import React from 'react';
import { IconButton, IconButtonProps } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";

type ActionsMenuOpenButtonProps = IconButtonProps

/**
 * MUI IconButton component styled in the SecurSpace way. Basic IconButton with a MoreHoriz button as a default child.
 * @param children children passed through to the internal IconButton component. Can be left out to use the default MoreHoriz icon
 * @param rest The rest of the IconButton props that will be passed through to the internal IconButton component
 * @constructor
 */
const ActionsMenuOpenButton = ({ children, ...rest }: ActionsMenuOpenButtonProps) => {
  return <IconButton aria-label="More actions" {...rest}>
    { children || <MoreHoriz />}
  </IconButton>
}

export { ActionsMenuOpenButton };